import { sha256 } from '@noble/hashes/sha2.js';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils.js';

/**
 * Generates a random-ish valid node-red logic node ID that is deterministically
 * based on the given base identifiers. The returned IDs are (in practice)
 * collision-free for any unique parameters.
 * @param baseIds array of base identifiers
 * @returns unique node-red logic ID based on the parameters
 */
export default function generateDeterministicNodeId(baseIds: (string | number)[]): string {
  const baseWord = baseIds.join('\n');
  const hex = bytesToHex(sha256(utf8ToBytes(baseWord)));
  return `${hex.slice(0, 7)}.${hex.slice(7, 14)}`;
}
